import React from 'react';

import { returnHostUrl } from '../util/axiosHelper';
import { messages } from '../util/constants';

export const AccessDenied = ({ message }) => {
  function redirect() {
    let url;
    if (returnHostUrl().isResi) {
      url = returnHostUrl().loginUrl;
    } else {
      url = returnHostUrl().smbLoginUrl;
    }
    window.location.replace(url);
  }

  let loginButton =
    message === messages.noAccessMessage ? null : (
      <button tabIndex={0} className="search-button" onClick={() => redirect()}>
        Login
      </button>
    );

  return (
    <>
      <div className={'card-container'}>
        <h1>You do not have sufficient access</h1>
        <h4>{message}</h4>
        {loginButton}
      </div>
    </>
  );
};
